import _ from "lodash";
import * as Yup from "yup";

export function generateValidationSchema(
  validationSchema: Yup.AnySchema | Record<string, Yup.AnySchema>
): Record<string, Yup.AnySchema> {
  return Object.entries(validationSchema).reduce((acc, [key, value]) => {
    if (_.isPlainObject(value) && !value.__isYupSchema__) {
      return {
        ...acc,
        [key]: Yup.object().shape(generateValidationSchema(value)),
      };
    }

    if (_.isArray(value)) {
      return {
        ...acc,
        [key]: Yup.array().of(Yup.object().shape(generateValidationSchema(value[0]))),
      };
    }

    return {
      ...acc,
      [key]: value,
    };
  }, {});
}
